import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { SpanComponent } from "@components/span/span.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Produkt } from "~app/common/models/produkt/ProduktSearchResponseDTO";
import { ProduktSearchResultViewModel } from "./produktSearchResultViewModel";

@Component({
    selector: "rask-produkt-search-result",
    templateUrl: "./produkt-search-result.component.html",
    styleUrls: ["./produkt-search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        SpanComponent,
        TranslatePipe
    ]
})
export class ProduktSearchResultComponent {
    results: ProduktSearchResultViewModel[];

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("results") set list(val: Produkt[]) {
        if (!val) {
            return;
        }
        this.results = val.map(x => new ProduktSearchResultViewModel(x));
    }
}
